import styled from 'styled-components';
import { Collapse, Form } from 'antd';

export const CollapseWrapper = styled(Collapse)`
	border: none;
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	box-shadow: none !important;
	border-radius: 12px !important;

	.ant-collapse-header {
		align-items: center !important;
	}

	.ant-collapse-content {
		border-top: none !important;
		background-color: #ffffff;
		border-radius: 0 0 10px 10px !important;
	}

	.ant-collapse-item {
		border: none;
		background-color: #ffffff;
		border-radius: 10px !important;
	}

	.ant-collapse-content-box {
		background-color: #ffffff;
		padding: 0.5rem 2rem 2rem 2rem;
		border-radius: 0 0 10px 10px !important;
	}

	.ant-collapse-header-text {
		font-weight: 600;
		font-size: 17px;
	}
`;

export const CustomFormItem = styled(Form.Item)`
	.ant-form-item-label {
		font-weight: 600;
	}

	.ant-form-item-required {
		font-size: 1rem;
		flex-direction: row-reverse;
	}

	.ant-form-item-required::before {
		color: #ff0000 !important;
	}

	.ant-form-item-required::after {
		width: 0;
		margin: 0 !important;
	}
`;
